import React, { Component } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import NavbarMenu from './components/layout/NavbarMenu';
import Login from './components/pages/Login/Login';
import Home from './components/pages/Home';
import classes from './App.module.scss';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    rest.authenticated === true
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

export default class App extends Component {
  
  state = {
    authenticated: false,
  }

  setAuth = (auth) => {
    this.setState({authenticated: auth});
  }

  render() {

    return (
      <div className={classes.appContainer}>
      <Router>
        {this.state.authenticated ? <NavbarMenu authenticated={this.state.authenticated}/>  : null}
        <Route exact path="/login" render={props => (
          <Login setAuth={this.setAuth} auth={this.state.authenticated} />
        )} />
        <PrivateRoute exact authenticated={this.state.authenticated} path="/" component={Home} />
      </Router>
      </div>
    );
  }
}
